import { render } from "./AboutBanner.vue?vue&type=template&id=58fc8d63&scoped=true"
import script from "./AboutBanner.vue?vue&type=script&lang=js"
export * from "./AboutBanner.vue?vue&type=script&lang=js"

import "./AboutBanner.vue?vue&type=style&index=0&id=58fc8d63&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58fc8d63"]])

export default __exports__